import { useGetUser } from '@/api';
import { LinkIcon } from '@/components/icons/drugomaniya';
import { Button } from '@/components/shared/Button';
import { useModalStore } from '@/store';

import cn from './styles.module.sass';

export const InviteFriendContent = () => {
    const { data: userData } = useGetUser();
    const { setIsInviteSuccessOpen, setIsInviteOpen } = useModalStore();

    const handleCopyLink = async () => {
        if (userData) {
            await navigator.clipboard.writeText(`${window.location.origin}/?ref=${userData?.id}`);
            setIsInviteOpen(false);
            setIsInviteSuccessOpen(true);
        }
    };

    return (
        <div className={cn.container}>
            <div className={cn.imgWrapper}>
                <img src="/images/main/friends.svg" alt="" />
            </div>
            <h2>
                Пригласить друга
                <br />
                зарабатывать
            </h2>
            <div className={cn.description}>
                <p>
                    После регистрации друга, его номер телефона появится у тебя в разделе Мои номера
                </p>
                <p>
                    После первой продажи друга, тебе будет начисляться 2 Б от суммы, которую он
                    получит за продажу каждый месяц, пока номер активен.
                </p>
            </div>
            <Button onClick={handleCopyLink} className={cn.copyLinkButton}>
                <span>{LinkIcon}</span>Скопировать ссылку
            </Button>
        </div>
    );
};
